<app-header title="self-serve.payrollSituation.whatsYourTimeline"></app-header>
<p class="text-color-secondary-font margin-bottom-6">
    {{ 'self-serve.payrollSituation.weWillPersonalizeTrial' | translate }}
</p>
<form #form="ngForm" [class.loading]="isLoading" (ngSubmit)="onSubmit()">
    <div class="responsive-grid margin-bottom-4">
        <label class="vertical">{{ 'self-serve.payrollSituation.desiredPayDate' | translate }}</label>
        <ui-date-picker
            [(ngModel)]="selfServeOnboarding.firstPaydayDate"
            [required]="!selfServeOnboarding.firstPaydayDateUndecided"
            #firstPaydayDate="ngModel"
            name="firstPaydayDate"
            [disabled]="selfServeOnboarding.firstPaydayDateUndecided"
            [placeholder]="
                (selfServeOnboarding.firstPaydayDateUndecided ? 'self-serve.undecided' : 'self-serve.selectADate')
                    | translate
            "
            hint="self-serve.payrollSituation.desiredPayDateHint"
            [hideRequiredMarker]="true"
            [minDate]="minFirstPaydayDate"
        >
        </ui-date-picker>

        <div>
            <mat-checkbox
                class="padding-top-2 padding-bottom-4"
                name="firstPaydayDateUndecided"
                [(ngModel)]="selfServeOnboarding.firstPaydayDateUndecided"
                (ngModelChange)="onChangeUndecided()"
                >{{ 'self-serve.payrollSituation.firstPaydayDateUndecided' | translate }}
            </mat-checkbox>
        </div>

        <div *ngIf="selfServeOnboarding.hasRunPayrollThisYear">
            <label class="vertical">{{ 'self-serve.payrollSituation.lastPaydayDate' | translate }}</label>
            <ui-date-picker
                [(ngModel)]="selfServeOnboarding.lastPaydayDate"
                #lastPaydayDate="ngModel"
                name="lastPaydayDate"
                [hideRequiredMarker]="true"
            >
            </ui-date-picker>
        </div>

        <div *ngIf="selfServeOnboarding.hasRunPayrollThisYear">
            <label class="vertical">{{ 'self-serve.payrollSituation.endDateOfLastPayPeriod' | translate }}</label>
            <ui-date-picker
                [(ngModel)]="selfServeOnboarding.endDateOfLastPayPeriod"
                #endDateOfLastPayPeriod="ngModel"
                name="endDateOfLastPayPeriod"
                [hideRequiredMarker]="true"
            >
            </ui-date-picker>
        </div>

        <label class="vertical">{{ 'self-serve.payrollSituation.paydayFrequency' | translate }}</label>
        <mat-form-field>
            <mat-select
                required
                name="templateId"
                #paydayFrequency="ngModel"
                [(ngModel)]="selfServeOnboarding.paydayFrequency"
            >
                <mat-option *ngFor="let frequency of paydayFrequencies" [value]="frequency">{{
                    'self-serve.' + frequency | translate
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.submitted && paydayFrequency.invalid">{{
                'self-serve.fieldRequired' | translate
            }}</mat-error>
        </mat-form-field>
    </div>

    <div class="flex buttons justify-end">
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>
